const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecordLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 20.9994C7.52894 20.9994 3.5 16.9704 3.5 11.9997C3.5 7.02991 7.52894 3 12.4997 3C17.4704 3 21.4994 7.02991 21.4994 11.9997",
    stroke: "#111111",
    style: {
      stroke: "#111111",
      stroke: "color(display-p3 0.0667 0.0667 0.0667)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.144 18.076C15.8356 17.1119 16.1956 16.0115 17.2075 15.6855C17.7397 15.5153 18.3215 15.6135 18.7681 15.9482C19.2156 15.6165 19.7955 15.5182 20.3267 15.6855C21.3386 16.0115 21.7015 17.1119 21.3931 18.076C20.9124 19.6016 18.7681 20.7789 18.7681 20.7789C18.7681 20.7789 16.6412 19.6201 16.144 18.076Z",
    stroke: "#111111",
    style: {
      stroke: "#111111",
      stroke: "color(display-p3 0.0667 0.0667 0.0667)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.319 14.2076C13.1798 15.3606 12.1329 16.1827 10.98 16.0436C9.82708 15.9054 9.00591 14.8575 9.14407 13.7046C9.2832 12.5517 10.3301 11.7305 11.483 11.8687C12.6359 12.0078 13.4581 13.0547 13.319 14.2076Z",
    stroke: "#07C160",
    style: {
      stroke: "#07C160",
      stroke: "color(display-p3 0.0275 0.7569 0.3765)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3203 14.2072L14.0754 7.94141C14.0754 7.94141 14.447 9.41833 15.8704 9.8902",
    stroke: "#07C160",
    style: {
      stroke: "#07C160",
      stroke: "color(display-p3 0.0275 0.7569 0.3765)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecordLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recordLogo.083ae57745e935512afb71a61fc698c1.svg";